import React, { useRef } from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';

import { I18nProvider, EntityMapperContext } from '@uncinc/react-drupal-core';

import { Container, KitchenSinkComponentMapperContext, SkipNav } from '@uncinc/uncinc-react-kitchen-sink';

import { Cookie, CustomRoute } from '../../components';
import { IS_CLIENT, SEARCH_PATH, MAIN_CONTENT_ID } from '../../config/constants';
import i18next from '../../config/i18next';
import { usePrevious } from '../../helpers/usePrevious';
import FooterMenu from '../../implementations/Menu/FooterMenu';

import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import profileMapper from '../../mappers/profile';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import Entity from '../Entity';
import Header from '../Header';
import Search from '../Search';

import './style.scss';
import '../../styles/main.scss';

const entityTypeMapper = {
  block: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  profile: profileMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

const kitchenSinkComponentMapper = {
  // @TODO: Uncomment the Button here.
  // Currently the button type 'text' doesn't work if we do.
  // Button,
};

const App = () => {
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Immutable.Map()));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const prevPath = usePrevious(path);
  const searchInputRef = useRef(null);

  const classes = classNames('App', rootClasses.join(' '), {
    'is-front-page': childEntity.get('is_front'),
    'not-found': !entityExists,
  });

  return (
    <EntityMapperContext.Provider value={entityTypeMapper}>
      <I18nProvider locale={language} i18next={i18next}>
        <KitchenSinkComponentMapperContext.Provider value={kitchenSinkComponentMapper}>
          <div className={classes} language={language}>
            <Container>
              <SkipNav searchRef={searchInputRef} />
            </Container>
            <Header searchInputRef={searchInputRef} />
            <main id={MAIN_CONTENT_ID} className="main" tabIndex={-1}>
              <Switch>
                {/* Add routes here */}
                <CustomRoute path={SEARCH_PATH} render={() => (<Search />)} />
                <Route render={() => (<Entity prevPath={prevPath} />)} />
              </Switch>
            </main>
            <FooterMenu />
            {IS_CLIENT && <Cookie />}
            <div id="modal-root" />
          </div>
        </KitchenSinkComponentMapperContext.Provider>
      </I18nProvider>
    </EntityMapperContext.Provider>
  );
};

export default App;
